import { CartAddEvent, CartUpdateEvent } from '@theme/events';

(function () {
  const loader = document.querySelector('.cart-loader');

  document.addEventListener('change', onVariantChange);

  function onVariantChange(event) {
    const select = event.target.closest('.line-item-option');
    if (!select) return;

    showLoader();

    const option = select.options[select.selectedIndex];
    if (!option) {
      hideLoader();
      return;
    }

    const variantData = getVariantData(option);
    if (!variantData) {
      hideLoader();
      return;
    }

    swapVariant(variantData);
  }

  function getVariantData(option) {
    const newVariantId = option.dataset.variantId;
    const oldVariantId = option.dataset.oldVariantId;
    const quantity = Number(option.dataset.itemQuantity) || 1;

    if (!newVariantId || !oldVariantId || newVariantId === oldVariantId) {
      return null;
    }

    const properties = {
      _cleaned_mpn: option.dataset.cleanedMpn || '',
      _mpn_size: option.dataset.mpnSize || '',
      _darveys_size: option.dataset.darveysSize || '',
      _darveys_size_unit: option.dataset.darveysSizeUnit || '',
      _boutique_size: option.dataset.boutiqueSize || '',
      _boutique_size_unit: option.dataset.boutiqueSizeUnit || '',
    };

    return { newVariantId, oldVariantId, quantity, properties  };
  }

  async function swapVariant({ oldVariantId, newVariantId, quantity, properties }) {
    try {
      await addVariant(newVariantId, quantity, properties);
      await removeVariant(oldVariantId);
      notifyTheme();
    } catch (err) {
      console.error('Variant switch error:', err);
    } finally {
      hideLoader();
    }
  }

  function removeVariant(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    }).then(validateResponse);
  }

  function addVariant(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    }).then(validateResponse);
  }

  function notifyTheme() {
    document.dispatchEvent(
      new CartUpdateEvent({}, 'variant-swap', {
        source: 'cart-items-component'
      })
    );
  }

  function validateResponse(res) {
    if (!res.ok) throw new Error('Cart request failed');
    return res;
  }

  function showLoader() {
    if (loader) loader.classList.remove('hidden');
  }

  function hideLoader() {
    if (loader) loader.classList.add('hidden');
  }
})();
